
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zapasy",
      function () {
        return require("private-next-pages/zapasy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zapasy"])
      });
    }
  